<div class="card mb-3" [attr.data-automation]="entity.id + '-delegate-card'">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="d-flex flex-row align-items-center">
      @if (photoBase64()) {
        <img [src]="'data:image/png;base64,' + photoBase64()" class="round-image-table" />
      }
      @if (!photoBase64()) {
        <i class="fa-2x round-image-table-icon" [ngClass]="ziroIcons.CIRCLE_USER"></i>
      }
      <h5 class="card-title ms-2 mb-0">{{ displayName() }}</h5>
    </span>
    <button
      class="btn btn-border p-0"
      (click)="removeDelegateClicked()"
      [attr.data-automation]="'remove-delegate-button'"
    >
      <i class="fa-2x" [ngClass]="ziroIcons.TIMES"></i>
    </button>
  </div>
  <div class="card-body">
    <ziro-checkbox [fieldId]="'makeCallsEnabled'"></ziro-checkbox>
    <ziro-checkbox [fieldId]="'receiveCallsEnabled'"></ziro-checkbox>
    <ziro-checkbox [fieldId]="'manageSettingsEnabled'"></ziro-checkbox>
  </div>
</div>
